import { render, staticRenderFns } from "./ViewSettingsHistory.vue?vue&type=template&id=05eff3d2&scoped=true&"
import script from "./ViewSettingsHistory.vue?vue&type=script&lang=js&"
export * from "./ViewSettingsHistory.vue?vue&type=script&lang=js&"
import style0 from "./ViewSettingsHistory.vue?vue&type=style&index=0&id=05eff3d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05eff3d2",
  null
  
)

export default component.exports